import _debounce from "lodash/debounce";

export default {
  props: {
    search: { type: Function },
    value: { type: String },
  },

  data() {
    return {
      keyword: "",
    };
  },

  methods: {
    debouncedSearch: _debounce(triggerSearch, 300),
    triggerSearch: triggerSearch,
    handleInputChange,
  },

  mounted() {
    if (this.value) {
      this.keyword = this.value;
    }
  },

  watch: {
    value: function (val) {
      this.keyword = val;
    },
  },
};

function triggerSearch() {
  this.$emit("on-typing-state-change", false);
  this.search(this.keyword);
}

function handleInputChange(e) {
  this.keyword = e.target.value;
  this.$emit("on-typing-state-change", true);
  this.debouncedSearch();
}
